import { stripedFill } from "../config/eventTypes";
import { Box, Typography } from "@mui/material";

export const LegendSwatch = ({
	label,
	bg,
	border,
	striped = false,
}: {
	label: string;
	bg: string;
	border: string;
	striped?: boolean;
}) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
		<Box
			sx={{
				width: 14,
				height: 14,
				borderRadius: "4px",
				backgroundColor: bg,
				...(striped && stripedFill(border, 3, 2)),
				border: "2px solid",
				borderStyle: striped ? "dashed" : "solid",
				borderColor: border,
			}}
		/>
		<Typography variant="caption" color="text.secondary">
			{label}
		</Typography>
	</Box>
);
